import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Admin Panel Screens
import AdminLayout from "./layouts/AdminLayout";
import AdminDashboard from "./pages/AdminDashboard";
import Registration from "./pages/Registration";
import HotelOwners from "./pages/HotelOwners";
import Guides from "./pages/Guides";
import Travelers from "./pages/Travelers";
import Withdrawal from "./pages/Withdrawal";
import Listings from "./pages/Listings";
import VisaManager from "./pages/VisaManage";
import Finance from "./pages/Finance";
import SolowayFinance from "./pages/SolowayFinance";
import SolowaySettings from "./pages/SolowaySettings";
import EventListing from "./pages/EventListing";
import CommissionManage from "./pages/CommissionManage";
import HotelOwnerDetailsPage from "./pages/HotelOwnerDetailsPage";
import GuideDetailsPage from "./pages/GuideDetailsPage";
import TravelerAgentDetailsPage from "./pages/TravelerAgentDetailsPage";
import HotelListingDetailsPage from "./pages/HotelListingDetailsPage";
import GuideListingDetailsPage from "./pages/GuideListingDetailsPage";
import AdminReviewManagement from "./pages/AdminReviewManagement";
import AdminSupportTickets from "./pages/AdminSupportTickets";
import AdminAuditLogs from "./pages/AdminAuditLogs";
import AdminRefunds from "./pages/AdminRefunds";
import AdminBroadcast from "./pages/AdminBroadcast";
import AdminSystemHealth from "./pages/AdminSystemHealth";
import AdminReports from "./pages/AdminReports";
import AIConciergeButton from "./components/AIConcierge/AIConciergeButton";
import MaintenanceOverlay from "./components/Maintenance/MaintenanceOverlay";


import HomePage from "./pages/Home/Home";
import Footer from "./components/Footer";
import AdminLogin from "./pages/AdminLogin";
import AdminRegister from "./pages/AdminRegister";
import AdminRegisterOtpPage from "./pages/AdminRegisterOtpPage";
import AdminHome from "./pages/AdminHome";
import TravelerHome from "./pages/TravelerHome";
import TravelerHotel from "./pages/TravelerHotel";
import HotelBooking from "./pages/HotelBooking";
import BookingConfirm from "./pages/BookingConfirm";
import GuideBooking from "./pages/GuideBooking";
import ReviewGuideBooking from "./pages/ReviewGuideBooking";
import GuideProfileBooking from "./pages/GuideProfileBooking";
import HotelListingForm from "./pages/HotelListingForm";
import TourListingForm from "./pages/TourListingForm";
import VisaApplication from "./pages/VisaApplication";
import TravelerProfile from "./pages/TravelerProfile";
import HotelSetting from "./pages/HotelSetting";
import BookingHistory from "./pages/BookingHistory";
import BookingList from "./pages/BookingList";
import HotelBookingList from "./pages/HotelBookingList";
import PaymentDetails from "./pages/PaymentDetails";
import GuideProfileSetting from "./pages/GuideProfileSetting";
import GuideBookingSummary from "./pages/GuideBookingSummary";
import LocalUser from "./pages/LocalUser";
import Insurance from "./pages/Insurance";
import SOS from "./pages/SOS";
import Register from "./pages/Register";
import Login from "./pages/Login";
import EmailVerify from "./pages/EmailVerify";
import EmailVerifyConfirm from "./pages/EmailVerifyConfirm";
import Notification from "./pages/Notification";
import Chat from "./pages/Message2";
import Message from "./pages/Message";
import BookingPaymentPage from "./pages/BookingPaymentPage";
import EventBooking from "./pages/EventBooking";
import EventList from "./pages/EventList";
import SuccessScreen from "./pages/SuccessScreen";
import TravelerToHotelOwnerRegister from "./pages/TravelerToHotelOwnerRegister";
import TravelerToGuideRegister from "./pages/TravelerToGuideRegister";
import TravelerToAgent from "./pages/TravelerToAgent";
import AgentHotelRegister from "./pages/AgentHotelRegister";
import AgentGuideRegister from "./pages/AgentGuideRegister";
import SetPassword from "./pages/SetPassword";
import CreatePassword from "./pages/CreatePassword";
import AgentHotelOwnerProfile from "./pages/AgentHotelOwnerProfile";
import AgentGuideProfile from "./pages/AgentGuideProfile";
import PublicListing from "./pages/PublicListing";
import PublicTourListing from "./pages/PublicTourListing";
import TourBookingList from "./pages/TourBookingList";
import PaymentSuccess from "./pages/PaymentSuccess";
import AgentHotelBookingList from "./pages/AgentHotelBookingList";
import AgentTourBookingList from "./pages/AgentTourBookingList";
import AddReview from "./pages/AddReview";
import AddTourReview from "./pages/AddTourReview";
import CreateEvent from "./pages/CreateEvent";
import TravelersAll from "./pages/TravelersAll";
import AgentCommissionWithdrawal from "./pages/AgentCommissionWithdrawal";
import EditProfile from "./pages/EditProfile";
import UpdateHotelListingForm from "./pages/UpdateHotelListingForm";
import PaymentResult from "./pages/PaymentResult";
import CoinTransactionHistory from "./pages/CoinTransactionHistory";
import BookingDetailsPage from "./pages/BookingDetailsPage";
import InviteFriends from "./pages/InviteFriends";
import Policies from "./pages/Policies";
import HotelsHubPage from "./pages/HotelsHubPage";
import GuidesHubPage from "./pages/GuidesHubPage";
import FamousPlacesPage from "./pages/FamousPlacesPage";
import NotFoundPage from "./pages/NotFoundPage";
import HotelMapButton from "./components/HotelMapExplorer/HotelMapButton";

const ProtectedRoute = () => {
  const token = localStorage.getItem("jwt_token");
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
};

export default function AppRoutes() {
  return (
    <Router>
      <ToastContainer />
      <Routes>
        {/* ================= PUBLIC DIRECT & SEO ROUTES ================= */}
        <Route path="/" element={<HomePage />} />

        {/* Core Exploration Feeds */}
        <Route path="/explore" element={<TravelerHome />} />
        <Route path="/home" element={<TravelerHome />} />
        <Route path="/dashboard" element={<TravelerHome />} />

        {/* Stays & Accommodations */}
        <Route path="/hotels" element={<HotelsHubPage />} />
        <Route path="/hotels/:city" element={<HotelsHubPage />} />
        <Route path="/sri-lanka-hotels" element={<HotelsHubPage />} />
        <Route path="/sri-lanka-hotels/:city" element={<HotelsHubPage />} />
        <Route path="/travelerhotel" element={<TravelerHotel />} />
        <Route path="/travelerhotel/:id" element={<TravelerHotel />} />
        <Route path="/explore-hotels" element={<TravelerHotel />} />

        {/* Guides & Trackers */}
        <Route path="/guides" element={<GuidesHubPage />} />
        <Route path="/sri-lanka-guides" element={<GuidesHubPage />} />
        <Route path="/guideprofilebook" element={<GuideProfileBooking />} />
        <Route path="/guideprofilebook/:id" element={<GuideProfileBooking />} />

        {/* Famous Places & Itinerary */}
        <Route path="/places" element={<FamousPlacesPage />} />
        <Route path="/places/:placeSlug" element={<FamousPlacesPage />} />
        <Route path="/most-famous-places-sri-lanka" element={<FamousPlacesPage />} />
        <Route path="/most-famous-places-sri-lanka/:placeSlug" element={<FamousPlacesPage />} />

        {/* Essential Services */}
        <Route path="/visa" element={<VisaApplication />} />
        <Route path="/visa-assistance" element={<VisaApplication />} />
        <Route path="/sri-lanka-visa-assistance" element={<VisaApplication />} />
        <Route path="/insurance" element={<Insurance />} />
        <Route path="/emergency" element={<SOS />} />
        <Route path="/sos" element={<SOS />} />

        {/* Business Policies & Payments.lk Merchant Compliance Routes */}
        <Route path="/policies" element={<Policies />} />
        <Route path="/terms-and-conditions" element={<Policies defaultTab="terms" />} />
        <Route path="/terms" element={<Policies defaultTab="terms" />} />
        <Route path="/terms-of-service" element={<Policies defaultTab="terms" />} />
        <Route path="/business-terms" element={<Policies defaultTab="terms" />} />
        <Route path="/privacy-policy" element={<Policies defaultTab="privacy" />} />
        <Route path="/privacy" element={<Policies defaultTab="privacy" />} />
        <Route path="/return-policy" element={<Policies defaultTab="refunds" />} />
        <Route path="/refund-policy" element={<Policies defaultTab="refunds" />} />
        <Route path="/cancellation-policy" element={<Policies defaultTab="refunds" />} />
        <Route path="/refunds" element={<Policies defaultTab="refunds" />} />
        <Route path="/returns" element={<Policies defaultTab="refunds" />} />

        {/* Authentication & Public Listings */}
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/email-verify" element={<EmailVerify />} />
        <Route path="/email-verify-confirm" element={<EmailVerifyConfirm />} />
        <Route path="/reset-password" element={<SetPassword />} />
        <Route path="/create-password" element={<CreatePassword />} />
        <Route path="/listing/:token" element={<PublicListing />} />
        <Route path="/tourlisting/:token" element={<PublicTourListing />} />

        {/* Admin Public Auth Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/adminlogin" element={<AdminLogin />} />
        <Route path="/admin/register" element={<AdminRegister />} />
        <Route path="/adminregister" element={<AdminRegister />} />
        <Route path="/admin/register/otp" element={<AdminRegisterOtpPage />} />
        <Route path="/adminregisterotp" element={<AdminRegisterOtpPage />} />

        {/* Legacy Footer Alias */}
        <Route path="/footer" element={<Footer />} />

        {/* ================= PROTECTED USER & PARTNER ROUTES ================= */}
        <Route element={<ProtectedRoute />}>
          {/* User Profile & Settings */}
          <Route path="/profile" element={<TravelerProfile />} />
          <Route path="/profile/:id" element={<TravelerProfile />} />
          <Route path="/profile/edit" element={<EditProfile />} />
          <Route path="/edit-profile" element={<EditProfile />} />
          <Route path="/travelerprofile/:id" element={<TravelerProfile />} />
          <Route path="/hotelownerprofile/:id" element={<TravelerProfile />} />
          <Route path="/guideprofile/:id" element={<TravelerProfile />} />

          {/* Social & Messaging */}
          <Route path="/messages" element={<Message />} />
          <Route path="/message" element={<Message />} />
          <Route path="/chat/:id" element={<Chat />} />
          <Route path="/notifications" element={<Notification />} />
          <Route path="/notification" element={<Notification />} />
          <Route path="/invite" element={<InviteFriends />} />
          <Route path="/invite-friends" element={<InviteFriends />} />
          <Route path="/rewards" element={<CoinTransactionHistory />} />
          <Route path="/wallet" element={<CoinTransactionHistory />} />
          <Route path="/coin-history" element={<CoinTransactionHistory />} />

          {/* Events Hub */}
          <Route path="/events" element={<EventList />} />
          <Route path="/event" element={<EventList />} />
          <Route path="/events/:id" element={<EventBooking />} />
          <Route path="/event/:id" element={<EventBooking />} />
          <Route path="/events/create" element={<CreateEvent />} />
          <Route path="/create-event" element={<CreateEvent />} />
          <Route path="/events/edit/:id" element={<CreateEvent />} />

          {/* Bookings & History */}
          <Route path="/bookings" element={<BookingHistory />} />
          <Route path="/bookings/history" element={<BookingHistory />} />
          <Route path="/bookinghistory" element={<BookingHistory />} />
          <Route path="/booking-history" element={<BookingHistory />} />
          <Route path="/bookinglist" element={<BookingList />} />
          <Route path="/booking/:bookingId" element={<BookingDetailsPage />} />
          <Route path="/bookings/:bookingId" element={<BookingDetailsPage />} />
          <Route path="/hotelbook" element={<HotelBooking />} />
          <Route path="/hotels/book" element={<HotelBooking />} />
          <Route path="/bookconfirm" element={<BookingConfirm />} />
          <Route path="/booking/confirm" element={<BookingConfirm />} />
          <Route path="/guidebook" element={<GuideBooking />} />
          <Route path="/guides/book" element={<GuideBooking />} />
          <Route path="/reviewguidebook" element={<ReviewGuideBooking />} />
          <Route path="/guideprofilebook" element={<GuideProfileBooking />} />
          <Route path="/guideprofilebook/:id" element={<GuideProfileBooking />} />
          <Route path="/bookingpayment/:type/:bookingId" element={<BookingPaymentPage />} />
          <Route path="/checkout/:type/:bookingId" element={<BookingPaymentPage />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-result" element={<PaymentResult />} />
          <Route path="/paymentdetails" element={<PaymentDetails />} />
          <Route path="/success" element={<SuccessScreen />} />
          <Route path="/add-review/:bookingId" element={<AddReview />} />
          <Route path="/add-tour-review/:tourBookingId" element={<AddTourReview />} />

          {/* Explorer Feed & Stays Aliases */}
          <Route path="/travelerhome" element={<TravelerHome />} />
          <Route path="/travelerhome/:userId" element={<TravelerHome />} />
          <Route path="/travelerhotel" element={<TravelerHotel />} />
          <Route path="/travelerhotel/:id" element={<TravelerHotel />} />
          <Route path="/explore-hotels" element={<TravelerHotel />} />
          <Route path="/localuser" element={<LocalUser />} />

          {/* Partner & Provider Applications */}
          <Route path="/become-hotel-owner" element={<TravelerToHotelOwnerRegister />} />
          <Route path="/partner/hotel" element={<TravelerToHotelOwnerRegister />} />
          <Route path="/travelertohotel" element={<TravelerToHotelOwnerRegister />} />

          <Route path="/become-guide" element={<TravelerToGuideRegister />} />
          <Route path="/partner/guide" element={<TravelerToGuideRegister />} />
          <Route path="/travelertoguide" element={<TravelerToGuideRegister />} />

          <Route path="/become-agent" element={<TravelerToAgent />} />
          <Route path="/partner/agent" element={<TravelerToAgent />} />
          <Route path="/traveler-to-agent" element={<TravelerToAgent />} />

          {/* Management - Hotel */}
          <Route path="/manage/hotel-bookings" element={<HotelBookingList />} />
          <Route path="/hotelbookinglist" element={<HotelBookingList />} />
          <Route path="/manage/hotel-settings" element={<HotelSetting />} />
          <Route path="/hotelsetting" element={<HotelSetting />} />
          <Route path="/hotel/new" element={<HotelListingForm />} />
          <Route path="/hotel/:ownerId" element={<HotelListingForm />} />
          <Route path="/hotelform" element={<HotelListingForm />} />
          <Route path="/update-hotel/:listingId" element={<UpdateHotelListingForm />} />

          {/* Management - Guide */}
          <Route path="/manage/tour-bookings" element={<TourBookingList />} />
          <Route path="/tourbookinglist" element={<TourBookingList />} />
          <Route path="/manage/guide-analytics" element={<GuideBookingSummary />} />
          <Route path="/guide-booking-summary" element={<GuideBookingSummary />} />
          <Route path="/manage/guide-settings" element={<GuideProfileSetting />} />
          <Route path="/guidesetting" element={<GuideProfileSetting />} />
          <Route path="/tours/new" element={<TourListingForm />} />
          <Route path="/tourform" element={<TourListingForm />} />
          <Route path="/tourform/:guideUserId" element={<TourListingForm />} />

          {/* Management - Agent */}
          <Route path="/partner/commissions" element={<AgentCommissionWithdrawal />} />
          <Route path="/agent-commission-withdrawal" element={<AgentCommissionWithdrawal />} />
          <Route path="/agent-hotel-register" element={<AgentHotelRegister />} />
          <Route path="/agent-guide-register" element={<AgentGuideRegister />} />
          <Route path="/agent-hotelowner-profile/:userId/:agentDetailsId" element={<AgentHotelOwnerProfile />} />
          <Route path="/agent/hotel-owner/:ownerId/:agentDetailsId/bookings" element={<AgentHotelBookingList />} />
          <Route path="/agent-guide-profile/:guideId/:agentDetailsId" element={<AgentGuideProfile />} />
          <Route path="/agent-tours/:agentDetailsId/:guideId/bookings" element={<AgentTourBookingList />} />
        </Route>

        {/* ================= ADMIN MANAGEMENT PORTAL ================= */}
        <Route path="/adminhome" element={<AdminHome />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="admindashboard" element={<AdminDashboard />} />
          <Route path="registration" element={<Registration />} />
          <Route path="hotelowners" element={<HotelOwners />} />
          <Route path="hotel-owners" element={<HotelOwners />} />
          <Route path="hotelowners/:ownerId" element={<HotelOwnerDetailsPage />} />
          <Route path="hotel-owners/:ownerId" element={<HotelOwnerDetailsPage />} />
          <Route path="guides" element={<Guides />} />
          <Route path="guides/:guideId" element={<GuideDetailsPage />} />
          <Route path="travelers" element={<Travelers />} />
          <Route path="travelers/:travelerId" element={<TravelerAgentDetailsPage />} />
          <Route path="all-travelers" element={<TravelersAll />} />
          <Route path="withdrawals" element={<Withdrawal />} />
          <Route path="withdrawal" element={<Withdrawal />} />
          <Route path="refunds" element={<AdminRefunds />} />
          <Route path="refund-management" element={<AdminRefunds />} />
          <Route path="listings" element={<Listings />} />
          <Route path="listings/hotels/:listingId" element={<HotelListingDetailsPage />} />
          <Route path="listings/guides/:tourId" element={<GuideListingDetailsPage />} />
          <Route path="reviews" element={<AdminReviewManagement />} />
          <Route path="review-management" element={<AdminReviewManagement />} />
          <Route path="tickets" element={<AdminSupportTickets />} />
          <Route path="support" element={<AdminSupportTickets />} />
          <Route path="broadcast" element={<AdminBroadcast />} />
          <Route path="audit-logs" element={<AdminAuditLogs />} />
          <Route path="visas" element={<VisaManager />} />
          <Route path="visa-applications" element={<VisaManager />} />
          <Route path="visamanager" element={<VisaManager />} />
          <Route path="events" element={<EventListing />} />
          <Route path="eventlisting" element={<EventListing />} />
          <Route path="commissions" element={<CommissionManage />} />
          <Route path="commissionmanage" element={<CommissionManage />} />
          <Route path="finance" element={<Finance />} />
          <Route path="solowayfinance" element={<SolowayFinance />} />
          <Route path="reports" element={<AdminReports />} />
          <Route path="settlements" element={<AdminReports />} />
          <Route path="system-health" element={<AdminSystemHealth />} />
          <Route path="health" element={<AdminSystemHealth />} />
          <Route path="settings" element={<SolowaySettings />} />
          <Route path="solowaysettings" element={<SolowaySettings />} />
        </Route>

        {/* 404 Fallback Route with noindex & navigation recovery */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <MaintenanceOverlay />
      <HotelMapButton />
      <AIConciergeButton />
    </Router>
  );
}
